import { ErrorResponse } from "@apollo/client/link/error";
import { print } from 'graphql';
import { getCId, getStoredUser, getUId } from '@coverright/utils';

export let graphqlErrorHandler: (errResponse: ErrorResponse) => void;

export const setErrorHandler = (callback: (errResponse: ErrorResponse) => void) => graphqlErrorHandler = callback;

export const errorTracker = (errResponse: ErrorResponse, token?: string) => {
  const errorObj: any = {
    graphQLErrors: errResponse.graphQLErrors,
    networkError: errResponse.networkError,
    cId: getCId(),
    uId: getUId(),
    request: {
      query: print(errResponse.operation.query),
      variables: errResponse.operation.variables
    },
    response: errResponse.response,
    env: getStoredUser(),
    version: (window as any).version,
    token
  }

  if (sessionStorage.getItem('filters')) {
    errorObj['maFilters'] = JSON.parse(sessionStorage.getItem('filters') as string);
  }

  if (sessionStorage.getItem('medigapFilters')) {
    errorObj['mgFilters'] = JSON.parse(sessionStorage.getItem('medigapFilters') as string);
  }

  if ((window as any).track) {
    (window as any)?.track('error', {
      message: 'request error',
      ...errorObj
    });
  }

  console.error(errorObj)
}
